import { initializeApp, getApps } from 'firebase/app';
import { getAnalytics, logEvent, setUserId, setUserProperties } from 'firebase/analytics';

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId:     process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const hasConfig = !!(firebaseConfig.apiKey && firebaseConfig.appId);

const app = hasConfig
  ? (getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0])
  : null;

const analytics = hasConfig && app && typeof window !== 'undefined'
  ? getAnalytics(app)
  : null;

// ── Helpers ────────────────────────────────────────────────────────────────────

export function trackPageView(pageName) {
  if (!analytics) return;
  logEvent(analytics, 'page_view', { page_title: pageName });
}

export function identifyUser(userId, role, schoolId) {
  if (!analytics) return;
  setUserId(analytics, userId);
  setUserProperties(analytics, { role, school_id: schoolId || 'none' });
}

export function clearAnalyticsUser() {
  if (!analytics) return;
  setUserId(analytics, null);
}

export function trackEvent(name, params = {}) {
  if (!analytics) return;
  logEvent(analytics, name, params);
}

export { analytics };
